module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAIAAAAbG2rfAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEkSURBVDhPpZPBasIwGMd9Ix8hxz3Cjh59BB8hR48+xBgLpdKt2GjHaBGxFXtocR2F4CjkkosQPHVS41yaxBH88R3+gX4/0u9re83dqIpjvY1Gry5AjqHcoR/N6VE8rih4GjgPwSan7AY12UDkwB0/98gKlgydZS0ON2GrwTRhbZQVOe4Fhcj/UMAnHLdJVtAVjL9FvlCv8aQ8iMMVk0LLoYDIHXctVooTGotJsU/Gi1BfvtufRikVWzArGJlvM215i9nAX+a/BtsX4VX0iHAsTcNGwYnaf8KkqD5A8CnyBb7/qtSdGhVl2Lf5tNI2yQqejZ5nyp11lCHws/Nwu7PgOQbIm6y7G/lbL+8eQG8eFS26cTISK21S7Qi7/utahSV3K5rmB6SUhi//fzoGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/88.png
// module id = 436
// module chunks = 1 2 3 4 5 6 7 8